import {
  PulldownTypeSelect,
  PulldownTypeSelectProps,
} from '@/components/GeneralInputs/PulldownTypeSelect';
import {
  PaymentRequestForm,
  TransactionProperty,
} from '@/features/InvoiceReport/Edit/type';
import { memo } from 'react';
import { useWatch } from 'react-hook-form';

type Props<TFieldValues extends PaymentRequestForm> = Omit<
  PulldownTypeSelectProps<TFieldValues>,
  'pulldownId'
> & {
  property: TransactionProperty;
};

const InnerPulldownTypeCell = <TFieldValues extends PaymentRequestForm>({
  control,
  inputId,
  property,
  name,
  rules,
}: Props<TFieldValues>) => {
  const optionIdValue = useWatch({
    control,
    name: name,
  });

  const optionId = optionIdValue ? String(optionIdValue) : undefined;

  return (
    <PulldownTypeSelect<TFieldValues>
      control={control}
      inputId={inputId}
      pulldownId={property.id}
      placeholder={property.placeholder}
      name={name}
      rules={rules}
      optionId={optionId}
    />
  );
};
InnerPulldownTypeCell.displayName = 'InnerPulldownTypeCell';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const PulldownTypeCell = memo(
  InnerPulldownTypeCell
) as typeof InnerPulldownTypeCell;
PulldownTypeCell.displayName = 'PulldownTypeCell';
